/* =========================
   CHEETAH TOKYO
   Generic Fade In Animation
========================= */

(() => {
  const FADE_SELECTOR = '.js-fadein, [data-fade]';

  const initFadeIn = () => {
    document.documentElement.classList.add('js-fade-ready');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const policyTargets = document.querySelectorAll(
      [
        '.shopify-policy__title',
        '.shopify-policy__body .rte > *',
        '.shopify-policy__body > *:not(.rte)'
      ].join(',')
    );

    policyTargets.forEach((element, index) => {
      if (!element.classList.contains('js-fadein') && !element.hasAttribute('data-fade')) {
        element.classList.add('js-fadein');
        element.setAttribute('data-fade', 'up');
        const delay = Math.min((index % 6) * 45, 225);
        element.style.setProperty('--fade-delay', `${delay}ms`);
      }
    });

    const fadeElements = Array.from(document.querySelectorAll(FADE_SELECTOR));

    if (!fadeElements.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      fadeElements.forEach((element) => {
        element.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observerInstance.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.08
      }
    );

    fadeElements.forEach((element) => {
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeIn);
  } else {
    initFadeIn();
  }
})();